import React from 'react';
import { ComponentBaseProps } from 'types';

type WrapperProps = {
  onClick?: () => void;
  children: React.ReactNode;
  id?: string;
} & ComponentBaseProps;

type OperatorWrapperProps = {
  isActive?: boolean;
} & WrapperProps;

export const CADButtonWrapper = ({
  id,
  onClick,
  children,
  isActive,
  style = {},
  className = '',
}: OperatorWrapperProps) => {
  return (
    <div
      id={id}
      onClick={onClick}
      style={style}
      className={`border w-full ${
        isActive ? 'border-wfBlue' : 'border-wfGrey100'
      } rounded flex-y-center ${className}`}
    >
      {children}
    </div>
  );
};

export const OperatorWrapper = ({
  id,
  onClick,
  children,
  isActive,
  style = {},
  className = '',
}: OperatorWrapperProps) => {
  return (
    <div
      id={id}
      onClick={onClick}
      className={`w-full ${
        isActive ? ' border-wfBlue' : 'border-wfGrey100'
      } hover:bg-gray-200 flex-center rounded-tl rounded-tr ${className}`}
      style={{
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const EyeWrapper = ({
  style,
  onClick,
  children,
  className = '',
}: WrapperProps) => {
  return (
    <div
      style={style}
      onClick={onClick}
      className={`border-t w-full hover:bg-gray-200 flex-center border-wfGrey100 py-[2px] cursor-pointer ${className}`}
    >
      {children}
    </div>
  );
};
